import { render, staticRenderFns } from "./BaseFormNewGate.vue?vue&type=template&id=bf27c960&scoped=true"
import script from "./BaseFormNewGate.vue?vue&type=script&lang=js"
export * from "./BaseFormNewGate.vue?vue&type=script&lang=js"
import style0 from "./BaseFormNewGate.vue?vue&type=style&index=0&id=bf27c960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf27c960",
  null
  
)

export default component.exports